export const allTheOtherFields = [
  // { label: 'Address', value: 'address' },
  // { label: 'Categories', value: 'categories' },
  { label: 'City', value: 'city' },
  { label: 'Categories', value: 'categories' },
  { label: 'Claimed', value: 'claimed' },
  { label: 'Country', value: 'country' },
  { label: 'Cuisines', value: 'cuisines' },
  { label: 'Date Added', value: 'dateAdded' },
  { label: 'Date Updated', value: 'dateUpdated' },
  { label: 'Descriptions', value: 'descriptions' },
  { label: 'Domains', value: 'domains' },
  // { label: 'Emails', value: 'emails' },
  { label: 'Facebook Page URL', value: 'facebookPageURL' },
  { label: 'Faxes', value: 'faxes' },
  { label: 'Features', value: 'features' },
  { label: 'Geo Location', value: 'geoLocation' },
  { label: 'Hours', value: 'hours' },
  { label: 'Image URLs', value: 'imageURLs' },
  { label: 'Is Closed', value: 'isClosed' },
  { label: 'Keys', value: 'keys' },
  { label: 'Languages Spoken', value: 'languagesSpoken' },
  { label: 'Latitude', value: 'latitude' },
  { label: 'Longitude', value: 'longitude' },
  { label: 'Menu Page URL', value: 'menuPageURL' },
  { label: 'Menus', value: 'menus' },
  { label: 'Name', value: 'name' },
  { label: 'Neighborhoods', value: 'neighborhoods' },
  { label: 'Num Employees Min', value: 'numEmployeesMin' },
  { label: 'Num Employees Max', value: 'numEmployeesMax' },
  { label: 'Num Room', value: 'numRoom' },
  { label: 'Payment Types', value: 'paymentTypes' },
  { label: 'People', value: 'people' },
  { label: 'Phones', value: 'phones' },
  { label: 'Postal Code', value: 'postalCode' },
  { label: 'Price Range Currency', value: 'priceRangeCurrency' },
  { label: 'Price Range Min', value: 'priceRangeMin' },
  { label: 'Price Range Max', value: 'priceRangeMax' },
  // { label: 'Primary Categories', value: 'primaryCategories' },
  { label: 'Products Or Services', value: 'productsOrServices' },
  { label: 'Province', value: 'province' },
  { label: 'Revenue Currency', value: 'revenueCurrency' },
  { label: 'Revenue Min', value: 'revenueMin' },
  { label: 'Revenue Max', value: 'revenueMax' },
  { label: 'Reviews', value: 'reviews' },
  { label: 'Rooms', value: 'rooms' },
  { label: 'SIC', value: 'sic' },
  { label: 'Source URLs', value: 'sourceURLs' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Websites', value: 'websites' },
  { label: 'Year Incorporated', value: 'yearIncorporated' },
  { label: 'Year Opened', value: 'yearOpened' },
];

export const mostCommonFieldsList = [
  { label: 'Address', value: 'address' },
  { label: 'Emails', value: 'emails' },
  { label: 'Primary Categories', value: 'primaryCategories' },
]
